import RecentInstruments from './recent-instrument-list/RecentInstrumentsList';

export default RecentInstruments;
